/*
 * @Author: liyxt
 * @Date: 2020-03-11 16:05:44
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-03 15:20:56
 * @Description: file content
 */
import { Component } from 'react';
import { setGlobalStorage, getGlobalStorage, clearMetaCache } from '@platform/api'

export default class Methods extends Component {
    getTopWindow() {
        let popWindows = [...document.querySelectorAll('.refer-pop-window')].filter(e => getComputedStyle(e).display === 'flex' || getComputedStyle(e).display === 'block');        // return !this.unitReferFocusFlag && popWindows.pop();
        return popWindows.pop();
    }

    toggleValueForMapOrObject(target, key, value) {
        if (target instanceof Map) {
            target.get(key) ? target.delete(key) : target.set(key, value);
        } else if (target instanceof Object) {
            target[key] ? delete target[key] : (target[key] = value);
        }
    }

    run(target, ...arg) {
        Array.isArray(target)
            ? target.forEach(func => {
                typeof func === 'function' && func(...arg);
            })
            : typeof target === 'function' && target(...arg);
    }

	// 存入storage
	setStorage = (key, value) => {
	    try {
	        setGlobalStorage('localStorage', key, value);
	    } catch (e) {
	        clearMetaCache();
	        // eslint-disable-next-line no-console
	        console.warn('storage has been cleared!');
	        setGlobalStorage('localStorage', key, value);
	    }
	};

	// 从storage中取值
	getStorage = key => {
	    return JSON.parse(getGlobalStorage('localStorage', key) || '{}');
	};
}
